.showFilter {
	display: flex;
	flex-wrap: wrap;
	padding: 6px 8px;
	gap: 6px;

	.item {
		display: flex;
		align-items: center;
		background-color: #ffffff;
		color: #374151;
		font-size: 13px;
		border-radius: 8px;
		padding: 4px 8px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

		.description {
			margin-right: 4px;
			color: #6b7280;
		}

		.label {
			font-weight: 600;
			margin-right: 6px;
			color: #111827;
		}

		.remove {
			cursor: pointer;
			width: 16px;
			height: 16px;
			color: #9ca3af;
			transition: color 0.2s ease;

			&:hover {
				color: #dc2626;
			}
		}
	}
}
